export const selectImage = (listImages: any) => {
  return listImages.filter((image: any) => image.position === 1)[0]
}

export const versionImage = (listVersion: any, isProcessed: any, version = "default") => {
  return isProcessed ? listVersion[version] || listVersion.default : listVersion.default
}
